import { ReactNode } from 'react';
import getRelayEnvironment from '../../../relayClientEnvironment';
import { Dispatch } from 'redux';
import { importModuleAndRenderNotification } from '../helpers/renderHelpers';

async function importTradeEnrollmentAndStatusUpdateLoader(): Promise<ReactNode> {
    const mod = await import(
        /* webpackChunkName: "TradeEnrollmentAndStatusUpdateLoader" */
        './TradeEnrollmentAndStatusUpdateLoader'
    );
    return mod.TradeEnrollmentAndStatusUpdateLoader;
}

type CustomActionType = {
    customActionType: {
        actionType: string;
    };
};

export const showTradeEnrollmentAndStatusUpdate = ({
    customActionType,
}: CustomActionType): $TSFixMe => (dispatch: Dispatch) => {
    importModuleAndRenderNotification({
        importFunc: importTradeEnrollmentAndStatusUpdateLoader,
        props: {
            environment: getRelayEnvironment(),
        },
    });

    return dispatch({ type: customActionType.actionType });
};
